import React from 'react';
import { useSelector } from 'react-redux';

import TransitionMenu from 'dpl/common/components/TransitionMenu';
import { isLessThanBreakpoint } from 'dpl/util/grid';

import { NAVIGATION } from '../utils/constants';

const IS_LT_XL = isLessThanBreakpoint('xl');

export default function BreedOverviewNavigation() {
  const tabIndex = useSelector(({ server }) => server.overviewNavTabIdx);

  return (
    <div className="BreedOverviewNavigation tc">
      <TransitionMenu
        itemPadding={IS_LT_XL ? 16 : 24}
        onItemClick={(_, index) => {
          const el = document.getElementById(Object.keys(NAVIGATION)[index]);

          el?.scrollIntoView({ behavior: 'smooth' });
        }}
        items={Object.values(NAVIGATION)}
        selectedIdx={tabIndex}
        itemClassName="pb2"
        className="dib"
        color="black"
      />
    </div>
  );
}
